const STORAGE_KEY = 'amitable:yandex-link-intent'
const CALLBACK_PARAM = 'yandexLinkIntent'
const INTENT_LIFETIME_MS = 10 * 60 * 1000

type LinkIntent = {
  token: string
  createdAt: number
}

export function createYandexLinkCallbackUrl(): string {
  const token = crypto.randomUUID()
  const intent: LinkIntent = { token, createdAt: Date.now() }
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent))

  const callbackUrl = new URL('/settings/general', window.location.origin)
  callbackUrl.searchParams.set(CALLBACK_PARAM, token)

  return callbackUrl.toString()
}

export function clearYandexLinkIntent(): void {
  window.sessionStorage.removeItem(STORAGE_KEY)
}

export function consumeYandexLinkIntent(): boolean {
  const callbackUrl = new URL(window.location.href)
  const token = callbackUrl.searchParams.get(CALLBACK_PARAM)
  if (!token) return false

  callbackUrl.searchParams.delete(CALLBACK_PARAM)
  window.history.replaceState(window.history.state, '', callbackUrl)

  const stored = window.sessionStorage.getItem(STORAGE_KEY)
  clearYandexLinkIntent()
  if (!stored) return false

  try {
    const intent = JSON.parse(stored) as Partial<LinkIntent>

    return (
      intent.token === token &&
      typeof intent.createdAt === 'number' &&
      Date.now() - intent.createdAt >= 0 &&
      Date.now() - intent.createdAt <= INTENT_LIFETIME_MS
    )
  } catch {
    return false
  }
}
